<template>
  <div class="country" v-if="country">
    <img :src="country.en.name | flagImg" />
    {{country[lang].name}}
  </div>
</template>

<script>
import fb from 'firebase'

export default {
  props: {
    key: null,
    lang: null
  },
  data: function() {
    return {
      country: {}
    }
  },
  ready: function() {
    let self = this

    fb.database().ref('countries/' + this.key)
    .on('value', function(snapshot) {
      self.country = snapshot.val()
    })

  }
}
</script>

<style lang="less">
  .country {
    img {
      margin-right: 10px;
    }
  }
</style>



/** WEBPACK FOOTER **
 ** Country.vue?a4be2538
 **/